import axios from 'axios'
import { getUserToken } from './utility/localStorageFunctions'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/locationServices-api`

export interface ScheduledFlightRequest {
  date: string // YYYY-MM-DD
  flightNumber: string
  isArrival: boolean
}

export interface FlightAirport {
  name: string
  iata: string
  countryName?: string
  countryCode?: string
  timeZone?: string
  latitude?: number
  longitude?: number
  terminal?: string
}

export interface ScheduledFlight {
  externalReference?: string
  departureTime?: string
  arrivalTime?: string
  departure: FlightAirport
  arrival: FlightAirport
  diverted?: { terminal?: string }
  estimatedFlightDuration?: number
  delays?: Record<string, any>
  status?: string
}

async function getScheduledFlight(
  params: ScheduledFlightRequest,
): Promise<ScheduledFlight | null> {
  const token = await getUserToken('locationServices')

  const response = await axios({
    method: 'get',
    url: `${BASE_URL}/flights/scheduled`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      date: params.date,
      flightNumber: params.flightNumber,
      isArrival: params.isArrival,
    },
  })

  return response.data ?? null
}

export const flightsAPI = {
  getScheduledFlight,
}
